import { useEffect, useState } from "react";
import firebase from "../firebase";

import DB_PATH from "../DB_PATH";
import { Author } from "../../types/Author";

type AuthorResponse = Author[];

export default ({ communityId }: { communityId: string }): AuthorResponse => {
  const [authors, setAuthors] = useState<Author[]>([]);

  useEffect(() => {
    if (!communityId) return;
    const unsubscribe = firebase
      .firestore()
      .collection(DB_PATH.AUTHOR)
      .where("communityId", "==", communityId)
      .onSnapshot(
        (snapshot) => {
          const authorsData = snapshot.docs
            .map((doc) => doc.data() as Author)
            .sort(
              (a, b) =>
                (a.position ?? Number.MAX_SAFE_INTEGER) -
                (b.position ?? Number.MAX_SAFE_INTEGER)
            );
          setAuthors(authorsData);
        },
        (error) => {
          console.error("Error fetching authors:", error);
        }
      );

    // Clean up the listener on unmount
    return () => unsubscribe();
  }, [communityId]);

  return authors;
};
